import { useTranslation } from "react-i18next"

export const WarningContentNoChannel = () => {
  const { t } = useTranslation()

  return (
    <>
      <p>{t("patient.information.contact.patientNotAbleTo")}</p>
      <ul className="ml-[0.563rem]">
        <li className="before:bg-on-surface-subdued relative indent-3 text-sm before:absolute before:top-2 before:left-0 before:size-1 before:rounded-full">
          {t("patient.information.contact.receiveConfirmationsReminders")}
        </li>
        <li className="before:bg-on-surface-subdued relative indent-3 text-sm before:absolute before:top-2 before:left-0 before:size-1 before:rounded-full">
          {t("patient.information.contact.downloadDocuments")}
        </li>
        <li className="before:bg-on-surface-subdued relative indent-3 text-sm before:absolute before:top-2 before:left-0 before:size-1 before:rounded-full">
          {t("patient.information.contact.uploadFiles")}
        </li>
      </ul>
      <p className="mt-5">{t("patient.information.contact.phoneNumberIsProvidedForTeleconsultations")}</p>
    </>
  )
}
